/**
 * Uncharted countries include so far:
 * SOL (Somaliland), excised from Somalia (SOM).
 **/
const fixUnchartedCountries = (countries, current) => (
    current === 'SOM'
    ? countries.concat(current, 'SOL')
    : countries.concat(current)
);


export default fixUnchartedCountries;
